// ID Card status definitions
export const ID_CARD_STATUSES = [
  { statusId: "20", status: "Id Card Applied By ESM", variant: "info" },
  {
    statusId: "22",
    status: "Id Card Rejected By Aresa Center",
    variant: "danger",
  },
  {
    statusId: "23",
    status: "Id Card Approval in progress",
    variant: "primary",
  },
  { statusId: "24", status: "Awaiting Documents from ESM", variant: "warning" },
  { statusId: "25", status: "Document Resubmitted by ESM", variant: "info" },
  {
    statusId: "26",
    status: "Id Card Approved by Branch User",
    variant: "success",
  },
  {
    statusId: "27",
    status: "Id Card Rejected By Branch User",
    variant: "danger",
  },
];

// Role-based permission configuration
export const ROLE_PERMISSIONS = {
  // ARESA Center - view only
  2: {
    canView: true,
    canUpdate: false,
    availableTabs: ["overview", "timeline", "details"],
  },
  // Branch - full permissions
  3: {
    canView: true,
    canUpdate: true,
    availableTabs: ["overview", "timeline", "details", "updateStatus"],
    allowedStatusUpdates: ["23", "24", "25", "26", "27"], // Mark in progress, Update document, Approve, Reject
  },
  // Admin roles - view only (5,6,7,8,9,10)
  5: {
    canView: true,
    canUpdate: false,
    availableTabs: ["overview", "timeline", "details"],
  },
  6: {
    canView: true,
    canUpdate: false,
    availableTabs: ["overview", "timeline", "details"],
  },
  7: {
    canView: true,
    canUpdate: false,
    availableTabs: ["overview", "timeline", "details"],
  },
  8: {
    canView: true,
    canUpdate: false,
    availableTabs: ["overview", "timeline", "details"],
  },
  9: {
    canView: true,
    canUpdate: false,
    availableTabs: ["overview", "timeline", "details"],
  },
  10: {
    canView: true,
    canUpdate: false,
    availableTabs: ["overview", "timeline", "details"],
  },
};

export const DEFAULT_PERMISSIONS = {
  canView: true,
  canUpdate: false,
  availableTabs: ["overview", "timeline", "details"],
};

// Status update action button configurations
export const STATUS_ACTIONS = [
  {
    statusId: "23",
    label: "Mark In Progress",
    icon: "bi-hourglass-split",

    style: {
      border: "1px solid #3949ab",
      background: "#3949ab",
    },
    // This button is visible for status 20 (applied) and 25 (document resubmitted)
    visibleForStatuses: ["20", "25"],
  },
  {
    statusId: "26",
    label: "Approve ID Card",
    icon: "bi-check-circle",
    style: {
      border: "1px solid #4caf50",
      background: "#4caf50",
    },
    // This button is visible for status 20, 23, 24, and 25
    visibleForStatuses: ["20", "23", "24", "25"],
  },
  {
    statusId: "27",
    label: "Reject ID Card",
    icon: "bi-x-circle",
    style: {
      border: "1px solid #dc3545",
      background: "#dc3545",
    },
    // This button is visible for status 20, 23, 24, and 25
    visibleForStatuses: ["20", "23", "24", "25"],
  },
  {
    statusId: "24",
    label: "Request For Document",
    icon: "bi-file-earmark-text",
    style: {
      border: "1px solid #ff9800",
      background: "#ff9800",
    },
    requiresRemarks: true,
    // This button is visible for status 20, 23, and 25
    visibleForStatuses: ["20", "23", "25"],
  },
];
